module.exports = __webpack_public_path__ + "static/challenger-ec48487c4a462fefe79ebc4c8532faa8.png";